export enum MfaContextType {
  Login = "login",
  ChangePhoneNumber = "changePhoneNumber",
  ResetPassword = "resetPassword",
  ChangePassword = "changePassword",
}
